export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <img src="/logo.png" alt="" />
          <span>Tiny Cloud</span>
        </div>

        <div className="footer-text">© {year} Tiny Cloud Ventures.</div>
      </div>
    </footer>
  );
}
